import { useState } from 'react';
import { promptInstall, useInstallMode } from '../lib/install';
import { Icon } from './Icon';

/** Az elrejtett ajanlat ennyi ideig nem jon vissza. */
const NUDGE_SNOOZE_MS = 30 * 24 * 60 * 60 * 1000;
const NUDGE_KEY = 'avslack:install-nudge-hidden-at';

function nudgeSnoozed(): boolean {
  try {
    const at = Number(localStorage.getItem(NUDGE_KEY));
    return Number.isFinite(at) && Date.now() - at < NUDGE_SNOOZE_MS;
  } catch {
    return false;
  }
}

function IosSteps() {
  return (
    <p className="text-ink-muted">
      iPhone-on: a Safariban koppints a <strong>Megosztás</strong> gombra (négyzet felfelé nyíllal),
      majd a <strong>Hozzáadás a főképernyőhöz</strong> pontra. Utána a kezdőképernyőről nyisd meg –
      csak így kapsz értesítést.
    </p>
  );
}

/**
 * Beallitasok: "Alkalmazas telepitese" (K2).
 *
 * Csak ott latszik, ahol van mit telepiteni: telepitett appban, asztali
 * alkalmazasban es telepitest nem ismero bongeszoben nem.
 */
export function InstallSection() {
  const mode = useInstallMode();
  if (!mode) return null;

  return (
    <section className="border-t border-border-soft pt-4 text-xs">
      <h3 className="mb-1.5 font-display text-sm font-semibold">Telepítés alkalmazásként</h3>
      {mode === 'ios' ? (
        <IosSteps />
      ) : (
        <>
          <p className="mb-2 text-ink-muted">
            Saját ikonnal, teljes képernyőn indul, és értesítést is kap akkor is, ha a böngésző
            nincs nyitva.
          </p>
          <button
            type="button"
            onClick={() => void promptInstall()}
            className="flex items-center gap-2 rounded-control bg-accent px-3 py-2 text-xs font-semibold text-accent-ink transition-colors hover:bg-accent-hover"
          >
            <Icon name="telepites" size="sm" />
            Telepítés
          </button>
        </>
      )}
    </section>
  );
}

/**
 * Telefonon egyszer felkinaljuk a telepitest - a lista felett.
 *
 * Csak ahol a bongeszo maga is telepitheto allapotot jelez (Android, Chrome).
 * iPhone-on az ertesites-ajanlo mar elmondja a lepeseket, ketszer ugyanazt
 * nem irjuk ki. Elrejtve egy honapig nem jon vissza.
 */
export function InstallNudge() {
  const mode = useInstallMode();
  const [hidden, setHidden] = useState(nudgeSnoozed);

  if (mode !== 'prompt' || hidden) return null;

  const hide = () => {
    try {
      localStorage.setItem(NUDGE_KEY, String(Date.now()));
    } catch {
      // privat mod: ebben a munkamenetben akkor is eltunik
    }
    setHidden(true);
  };

  return (
    <div className="flex items-center gap-3 border-b border-border-soft bg-accent-soft/50 px-4 py-2 text-sm md:hidden">
      <span aria-hidden="true" className="shrink-0 text-accent">
        <Icon name="telepites" />
      </span>
      <p className="min-w-0 flex-1 text-ink-muted">Tedd ki az AVSlacket a kezdőképernyőre.</p>
      <button
        type="button"
        onClick={() => void promptInstall().then((done) => done && hide())}
        className="shrink-0 rounded-control bg-accent px-3 py-1 text-xs font-semibold text-accent-ink transition-colors duration-(--duration-quick) hover:bg-accent-hover"
      >
        Telepítés
      </button>
      <button
        type="button"
        onClick={hide}
        title="Elrejtés"
        aria-label="Elrejtés"
        className="grid size-7 shrink-0 place-items-center rounded-control text-ink-faint transition-colors duration-(--duration-quick) hover:bg-surface-hover hover:text-ink"
      >
        <Icon name="bezaras" size="sm" />
      </button>
    </div>
  );
}
